import { createSlice } from "@reduxjs/toolkit";
import { getPerformance } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

const initialState = {status:API_STATUS.IDEL, data:{}};
const performanceSlice = createSlice({
    name:'performance',
    initialState,
    reducers:{
        resetPerformance(state){
            state.data={}
        }
     },
    extraReducers:(builder)=>{
        builder.addCase(getPerformance.fulfilled, (state, action)=> {
            state.data = action.payload;
            state.status = API_STATUS.SUCCESS;
        }),
        builder.addCase(getPerformance.pending, (state)=> {
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(getPerformance.rejected, (state)=> { 
            state.status = API_STATUS.ERROR;
        })
    }
});

export const {resetPerformance} = performanceSlice.actions;
export default performanceSlice.reducer;